// Reusable premium browser-window that frames an image.
export const BrowserMockup = ({
  src,
  mobileSrc,
  alt,
  label = "getvisibledesign.com",
  className = "",
  imgClass = "",
  loading = "lazy",
  fetchPriority = "auto",
}) => {
  return (
    <div
      className={`overflow-hidden rounded-2xl border border-line bg-white shadow-[0_30px_80px_-30px_rgba(23,21,15,0.35)] ${className}`}
    >
      <div className="flex items-center gap-2 border-b border-line bg-mist/80 px-4 py-3">
        <span className="h-3 w-3 rounded-full bg-[#f0605c]" />
        <span className="h-3 w-3 rounded-full bg-[#f6bc3d]" />
        <span className="h-3 w-3 rounded-full bg-[#3fce6a]" />

        <div className="ml-3 flex-1">
          <div className="mx-auto flex max-w-[220px] items-center justify-center gap-2 rounded-full border border-line bg-white px-3 py-1">
            <span className="h-2 w-2 rounded-full bg-grad" />
            <span className="text-xs text-ink">{label}</span>
          </div>
        </div>
      </div>

      <picture>
       {mobileSrc && (
         <source
           media="(max-width: 767px)"
           srcSet={mobileSrc}
         />
       )}

       <img
         src={src}
         alt={alt}
         loading={loading}
         fetchPriority={fetchPriority}
         className={`w-full h-auto object-contain md:aspect-[16/10] md:object-cover ${imgClass}`}
       />
      </picture>
    </div>
  );
};

// Small floating "chip" card used to decorate the hero.
export const Chip = ({ icon: Icon, label, className = "", style }) => (
  <div
    className={`flex items-center gap-2.5 rounded-2xl border border-line bg-white/90 px-4 py-3 shadow-[0_18px_40px_-20px_rgba(23,21,15,0.35)] ${className}`}
    style={style}
  >
    <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-grad text-white">
      <Icon className="h-4.5 w-4.5" style={{ width: 18, height: 18 }} />
    </span>

    <span className="text-sm font-medium text-ink">{label}</span>
  </div>
);